<template>
    <div id="User">
        <b-container>
            <b-row>
                <b-col cols="4">
                    {{$t('LOGIN')}}
                    {{ user.userName }}
                </b-col>
                <b-col cols="4">
                    {{$t('FST_NAME')}}
                    {{ user.userFirstName }}
                </b-col>
                <b-col cols="4">
                    {{$t('LST_NAME')}}
                    {{ user.userLastName }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    Email
                    {{ user.userEmail }}
                </b-col>
                <b-col cols="4">
                    Confirmed
                    {{ user.emailConfirmed }}
                </b-col>
                <b-col cols="4">
                    {{ $t('DATE') }}
                    {{ user.regDate }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    {{ $t('BLOCKED') }}
                    {{ user.blocked }}
                </b-col>
                <b-col cols="4">
                    Reason
                    {{ user.blockReason }}
                </b-col>
                <b-col cols="4">
                    BlockDate
                    {{ user.blockDate }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    Lat
                    {{ user.curLat }}
                </b-col>
                <b-col cols="4">
                    Lng
                    {{ user.curLng }}
                </b-col>
                <b-col cols="4">
                    Zoom
                    {{ user.curZoom }}
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    Pub
                    {{ user.numPubItems }}
                </b-col>
                <b-col cols="4">
                    Lang
                    {{ user.userLang }}
                </b-col>

            </b-row>
            <b-row>
                <b-col cols="4">
                    {{$t('TYPE')}}
                    {{ user.userType }}
                </b-col>
                <b-col cols="4" v-if="user.userType==='c'">
                    {{$t('COMPANY')}}
                    {{ user.companyName }}
                </b-col>
                <b-col cols="4" v-if="user.userType==='c' || user.userType==='g'">
                    URL
                    {{ user.homeUrl }}
                </b-col>
            </b-row>


            <b-row align-v="center">
                <b-col cols="4">
                    {{ user.avatarUrl }}
                    <b-img :src="user.avatarUrl" fluid alt="" style="height:8rem;width:auro"></b-img>
                </b-col>
                <b-col cols="4"></b-col>
                <b-col cols="4">
                    <b-button @click="fixCompany()">Fix</b-button>
                </b-col>

            </b-row>
        </b-container>
        <b-container fluid class="footer text-center">
            {{ user.name}}
        </b-container>


    </div>
</template>

<script>
import { BContainer, BRow, BCol, BImg, BButton } from 'bootstrap-vue';

export default {
  name: 'User',
  components: {
    BContainer, BRow, BCol, BImg, BButton
  },
  data: function() {
    return {
      userName: '',
      user: {}
    }
  },
  mounted() {
    this.userName = this.$rmEncHyp(this.$route.query.userName);
    this.getUser();
  },
  methods: {
    async getUser() {
        try {
            const response = await this.$http.get('getUserR', {
                params: {
                    userName: this.userName
                }
            });
            this.user = response.data;
            if(!this.user.avatarUrl) {
                this.user.avatarUrl = 'data/avat/'+this.userName+'.png';
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async fixCompany() {
        //alert(this.userName);
        try {
            const response = await this.$http.get('fixCompany', {
                params: {
                    userName: this.userName
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  }
}

</script>

<style>
</style>